import { ReadMore } from '@scripts/read-more/classes/ReadMore.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.workshop-hero').forEach(hero => {
        new ReadMore(hero, 'workshop-hero');
    });
});
